import './css/TableItem.css';
import { TABLE_STATUS } from '../../../../constants/enums';

export default function TableItem({ table, onClick , hasBooking}) {
  const getStatusClass = (status) => {
    switch (status) {
      case TABLE_STATUS.AVAILABLE:
        return 'available';
      case TABLE_STATUS.IN_SERVICE:
        return 'in-service';
      case TABLE_STATUS.OUT_OF_SERVICE:
        return 'out-of-service';
      default:
        return 'available';
    }
  };

  return (
    <div
      className={`table-item ${getStatusClass(table.status)}`}
      style={{
        left: `${table.position.x}px`,
        top: `${table.position.y}px`,
      }}
      onClick={() => onClick(table)}
    >
      {hasBooking && 
        <img src='/icons/mark.png' alt="" className="booked-marker"></img>
      }
      <span className="table-item-number">{table.tableId}</span>
    </div>
  );
}